import { render, staticRenderFns } from "./VideoPreviewModal.vue?vue&type=template&id=08df7935"
import script from "./VideoPreviewModal.vue?vue&type=script&lang=js"
export * from "./VideoPreviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports